import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableSummaryReport = Loadable({
  loader: function loader() {
    return import('../SummaryReport.jsx');
  },
  loading: ComponentLoading
});
export default LoadableSummaryReport;